var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.60573 8.36786V1.39464C7.60573 0.625108 8.23084 0 9.00037 0C9.76991 0 10.395 0.625108 10.395 1.39464V8.36786C10.395 9.13739 9.76991 9.7625 9.00037 9.7625C8.23084 9.7625 7.60573 9.13739 7.60573 8.36786ZM14.5286 2.04493C14.0768 1.6872 13.4176 1.76571 13.0599 2.21824C12.7021 2.67152 12.7799 3.32922 13.2332 3.68769C14.8922 4.99642 15.8432 6.95618 15.8432 9.06555C15.8432 12.8384 12.7732 15.9084 9.00111 15.9084C5.22824 15.9084 2.15825 12.8384 2.15825 9.06555C2.15825 6.95692 3.10851 4.9979 4.76608 3.68991C5.21936 3.33218 5.29712 2.67448 4.93939 2.22047C4.58166 1.76719 3.9247 1.69016 3.46994 2.04715C1.30651 3.75435 0.065918 6.31255 0.065918 9.06555C0.065918 13.9923 4.07431 18 9.00037 18C13.9264 18 17.9348 13.9916 17.9348 9.06555C17.9348 6.31107 16.6928 3.75287 14.5286 2.04493Z",
    fill: "#686868",
    fillOpacity: 0.76
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.802362e5.svg";
export { ForwardRef as ReactComponent };